var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _b;
import { PaymentClientError, PaymentErrorShortCodes } from '..';
import { PaymentMethod } from '../Interfaces/interface.request';
import { PaymentAdapter, PaymentVendors } from '../Interfaces/interface.adapter';
import { Base64 } from 'js-base64';
import dropin from 'braintree-web-drop-in';
var BrainTreePaymentMethod;
(function (BrainTreePaymentMethod) {
    BrainTreePaymentMethod["card"] = "card";
    BrainTreePaymentMethod["paypal"] = "paypal";
})(BrainTreePaymentMethod || (BrainTreePaymentMethod = {}));
var DropInPaymentMethod;
(function (DropInPaymentMethod) {
    DropInPaymentMethod["CreditCard"] = "CreditCard";
    DropInPaymentMethod["PayPalAccount"] = "PayPalAccount";
})(DropInPaymentMethod || (DropInPaymentMethod = {}));
var supportedPaymentMethodList = (_a = {},
    _a[PaymentMethod.webDropInCreditCard] = BrainTreePaymentMethod.card,
    _a[PaymentMethod.webDropInPaypal] = BrainTreePaymentMethod.paypal,
    _a);
var dropInPaymentMethodMapping = (_b = {},
    _b[DropInPaymentMethod.CreditCard] = PaymentMethod.webDropInCreditCard,
    _b[DropInPaymentMethod.PayPalAccount] = PaymentMethod.webDropInPaypal,
    _b);
var PaymentAdapterBrainTree = /** @class */ (function (_super) {
    __extends(PaymentAdapterBrainTree, _super);
    function PaymentAdapterBrainTree(env, vendorSessionInfo, billingContactInfo) {
        var _this = _super.call(this) || this;
        _this.vendorName = PaymentVendors.braintree;
        _this.supportedPaymentMethods = supportedPaymentMethodList;
        _this.sessionPaymentMethod = [];
        _this.env = env;
        _this.vendorSessionInfo = vendorSessionInfo;
        _this.billingContactInfo = billingContactInfo;
        _this.paymentMethodPayload = '';
        _this.threeDSecurePayload = undefined;
        return _this;
    }
    Object.defineProperty(PaymentAdapterBrainTree.prototype, "threeDSPayload", {
        set: function (payload) {
            if (!payload) {
                throw new PaymentClientError('Invalid 3DS payload', PaymentErrorShortCodes.invalid_3ds_payload);
            }
            this.threeDSecurePayload = payload;
        },
        enumerable: false,
        configurable: true
    });
    PaymentAdapterBrainTree.prototype.validatePaymentMethod = function (paymentMethods) {
        var _this = this;
        if (!paymentMethods.length) {
            throw new PaymentClientError("No valid payment method passed.", PaymentErrorShortCodes.missing_valid_payment_method);
        }
        var _a = paymentMethods.reduce(function (prev, method) {
            var mappedMethod = _this.supportedPaymentMethods[method];
            if (!mappedMethod) {
                return __assign(__assign({}, prev), { notSupportedPaymentMethods: __spreadArray(__spreadArray([], prev.notSupportedPaymentMethods, true), [method], false) });
            }
            return __assign(__assign({}, prev), { supportedPaymentMethods: __spreadArray(__spreadArray([], prev.supportedPaymentMethods, true), [mappedMethod], false) });
        }, { notSupportedPaymentMethods: [], supportedPaymentMethods: [] }), notSupportedPaymentMethods = _a.notSupportedPaymentMethods, supportedPaymentMethods = _a.supportedPaymentMethods;
        if (notSupportedPaymentMethods.length) {
            throw new PaymentClientError("Payment Method (".concat(notSupportedPaymentMethods.join(','), ") is not supported."), PaymentErrorShortCodes.unsupported_payment_method);
        }
        this.sessionPaymentMethod = supportedPaymentMethods;
    };
    PaymentAdapterBrainTree.prototype.encryptCreditCardData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('encryptCreditCardData is not supported with BrainTree integration');
            });
        });
    };
    PaymentAdapterBrainTree.prototype.encryptACHData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('encryptACHData is not supported with BrainTree integration');
            });
        });
    };
    PaymentAdapterBrainTree.prototype.initializeWebComponent = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                throw new Error('initializeWebComponent is not supported with BrainTree integration');
            });
        });
    };
    PaymentAdapterBrainTree.prototype.initializeWebDropIn = function (divId, paymentMethods) {
        var _this = this;
        // eslint-disable-next-line no-async-promise-executor
        return new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
            var brainTreeSession, paypalConfig, selectedPaymentMethod_1, _a, selectedDiv, dropInFormElement, dropInSubmitElement_1, dropInEmptyContainer, isThreeDSPayment_1, dropInInstance_1, error_1;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 3, , 4]);
                        this.validatePaymentMethod(paymentMethods);
                        return [4 /*yield*/, this.getDecodedVendorSessionPayload()];
                    case 1:
                        brainTreeSession = _b.sent();
                        paypalConfig = void 0;
                        selectedPaymentMethod_1 = undefined;
                        _a = [
                            document.getElementById(divId),
                            document.createElement('form'),
                            document.createElement('input'),
                            document.createElement('div')
                        ], selectedDiv = _a[0], dropInFormElement = _a[1], dropInSubmitElement_1 = _a[2], dropInEmptyContainer = _a[3];
                        if (!selectedDiv) {
                            throw new PaymentClientError("Selected element (".concat(divId, ") cannot be found."), PaymentErrorShortCodes.missing_element_provided, {
                                cause: 'Provided element cannot be found.'
                            });
                        }
                        if (this.sessionPaymentMethod.includes(BrainTreePaymentMethod.paypal)) {
                            paypalConfig = { flow: 'vault' };
                        }
                        dropInSubmitElement_1.id = 'web-drop-in-submit-button';
                        dropInSubmitElement_1.type = 'submit';
                        dropInSubmitElement_1.value = 'Submit';
                        dropInSubmitElement_1.style.width = '100%';
                        dropInSubmitElement_1.style.borderRadius = '5px';
                        dropInSubmitElement_1.setAttribute('disabled', 'disabled');
                        dropInFormElement.appendChild(dropInEmptyContainer);
                        dropInFormElement.appendChild(dropInSubmitElement_1);
                        selectedDiv.appendChild(dropInFormElement);
                        isThreeDSPayment_1 = !!this.threeDSecurePayload;
                        return [4 /*yield*/, dropin.create({
                                container: dropInEmptyContainer,
                                authorization: brainTreeSession.clientToken,
                                paypal: paypalConfig,
                                paymentOptionPriority: this.sessionPaymentMethod,
                                threeDSecure: isThreeDSPayment_1,
                                dataCollector: isThreeDSPayment_1
                            })];
                    case 2:
                        dropInInstance_1 = _b.sent();
                        dropInInstance_1.on('paymentMethodRequestable', function (payload) {
                            var dropInSelectedMethod = dropInPaymentMethodMapping[payload.type];
                            if (dropInSelectedMethod) {
                                selectedPaymentMethod_1 = dropInSelectedMethod;
                                dropInSubmitElement_1.removeAttribute('disabled');
                            }
                        });
                        dropInFormElement.addEventListener('submit', function (formEvent) { return __awaiter(_this, void 0, void 0, function () {
                            var paymentOptions, paymentResponse, encryptedData, _a, liabilityShifted, threeDSecureInfo, error_2;
                            return __generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _b.trys.push([0, 2, , 3]);
                                        formEvent.preventDefault();
                                        if (!selectedPaymentMethod_1) {
                                            throw ((new PaymentClientError('No payment method selected.', PaymentErrorShortCodes.missing_payment_method),
                                                { cause: 'No payment method selected.' }));
                                        }
                                        paymentOptions = { threeDSecure: { amount: '' } };
                                        if (this.threeDSecurePayload) {
                                            paymentOptions = { threeDSecure: this.threeDSecurePayload };
                                        }
                                        return [4 /*yield*/, dropInInstance_1.requestPaymentMethod(paymentOptions)];
                                    case 1:
                                        paymentResponse = _b.sent();
                                        encryptedData = { nonce: paymentResponse.nonce, deviceData: paymentResponse === null || paymentResponse === void 0 ? void 0 : paymentResponse.deviceData };
                                        if (isThreeDSPayment_1 && selectedPaymentMethod_1 == PaymentMethod.webDropInCreditCard) {
                                            _a = paymentResponse, liabilityShifted = _a.liabilityShifted, threeDSecureInfo = _a.threeDSecureInfo;
                                            if (!liabilityShifted) {
                                                throw new PaymentClientError('Invalid 3DS challenge.', PaymentErrorShortCodes.invalid_3ds_challenge, {
                                                    cause: 'Invalid 3DS challenge - Cannot shift liability'
                                                });
                                            }
                                            encryptedData = __assign(__assign({}, encryptedData), { threeDSecureInfo: threeDSecureInfo });
                                        }
                                        return [2 /*return*/, resolve({ paymentMethod: selectedPaymentMethod_1, encryptedPayment: Base64.toBase64(JSON.stringify(encryptedData)) })];
                                    case 2:
                                        error_2 = _b.sent();
                                        return [2 /*return*/, reject(error_2)];
                                    case 3: return [2 /*return*/];
                                }
                            });
                        }); });
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _b.sent();
                        reject(error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); });
    };
    PaymentAdapterBrainTree.prototype.formatThreeDSecurePayload = function (payload) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4, _5, _6, _7;
        if (!payload || !Object.keys(payload).length) {
            throw new PaymentClientError("3DS payload cannot be empty.", PaymentErrorShortCodes.invalid_3ds_payload, {
                cause: '3DS payload cannot be empty..'
            });
        }
        if (!(payload === null || payload === void 0 ? void 0 : payload.amount)) {
            throw new PaymentClientError("Transaction amount is not provided (3DS).", PaymentErrorShortCodes.missing_transaction_amount_3ds, {
                cause: 'Transaction amount is not provided (3DS).'
            });
        }
        var threeDSPayload = {
            amount: payload.amount,
            email: (_a = payload === null || payload === void 0 ? void 0 : payload.contact) === null || _a === void 0 ? void 0 : _a.email,
            mobilePhoneNumber: (_b = payload === null || payload === void 0 ? void 0 : payload.contact) === null || _b === void 0 ? void 0 : _b.mobileNumber,
            billingAddress: {
                givenName: (_c = payload === null || payload === void 0 ? void 0 : payload.name) === null || _c === void 0 ? void 0 : _c.first,
                surname: (_d = payload === null || payload === void 0 ? void 0 : payload.name) === null || _d === void 0 ? void 0 : _d.last,
                phoneNumber: ((_e = payload === null || payload === void 0 ? void 0 : payload.contact) === null || _e === void 0 ? void 0 : _e.phone) || ((_f = payload === null || payload === void 0 ? void 0 : payload.contact) === null || _f === void 0 ? void 0 : _f.mobileNumber),
                streetAddress: (_g = payload === null || payload === void 0 ? void 0 : payload.address) === null || _g === void 0 ? void 0 : _g.address1,
                extendedAddress: (_h = payload === null || payload === void 0 ? void 0 : payload.address) === null || _h === void 0 ? void 0 : _h.address2,
                locality: ((_j = payload === null || payload === void 0 ? void 0 : payload.address) === null || _j === void 0 ? void 0 : _j.state) || ((_k = payload === null || payload === void 0 ? void 0 : payload.address) === null || _k === void 0 ? void 0 : _k.city),
                postalCode: (_l = payload === null || payload === void 0 ? void 0 : payload.address) === null || _l === void 0 ? void 0 : _l.zip,
                countryCodeAlpha2: (_m = payload === null || payload === void 0 ? void 0 : payload.address) === null || _m === void 0 ? void 0 : _m.country
            },
            additionalInformation: {
                workPhoneNumber: ((_p = (_o = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _o === void 0 ? void 0 : _o.contact) === null || _p === void 0 ? void 0 : _p.phone) || ((_r = (_q = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _q === void 0 ? void 0 : _q.contact) === null || _r === void 0 ? void 0 : _r.mobileNumber),
                shippingGivenName: (_t = (_s = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _s === void 0 ? void 0 : _s.name) === null || _t === void 0 ? void 0 : _t.first,
                shippingSurname: (_v = (_u = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _u === void 0 ? void 0 : _u.name) === null || _v === void 0 ? void 0 : _v.last,
                shippingAddress: {
                    streetAddress: (_x = (_w = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _w === void 0 ? void 0 : _w.address) === null || _x === void 0 ? void 0 : _x.address1,
                    extendedAddress: (_z = (_y = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _y === void 0 ? void 0 : _y.address) === null || _z === void 0 ? void 0 : _z.address2,
                    locality: ((_1 = (_0 = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _0 === void 0 ? void 0 : _0.address) === null || _1 === void 0 ? void 0 : _1.state) || ((_3 = (_2 = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _2 === void 0 ? void 0 : _2.address) === null || _3 === void 0 ? void 0 : _3.city),
                    postalCode: (_5 = (_4 = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _4 === void 0 ? void 0 : _4.address) === null || _5 === void 0 ? void 0 : _5.zip,
                    countryCodeAlpha2: (_7 = (_6 = payload === null || payload === void 0 ? void 0 : payload.shipping) === null || _6 === void 0 ? void 0 : _6.address) === null || _7 === void 0 ? void 0 : _7.country
                }
            }
        };
        return threeDSPayload;
    };
    return PaymentAdapterBrainTree;
}(PaymentAdapter));
export { PaymentAdapterBrainTree };
